import React from 'react'
import './css/Loading.css'

const Loading = () => {
  return (
    <div className='loadingWrapper'>
      <div class="loader"></div>
    </div>
  )
}

export default Loading
